import { inject, Injectable } from '@angular/core';
import {  CanActivate } from '@angular/router';
import { SharedService } from '../service/shared.service';

/**
 * 匿名用户验证
 *
 * @version 1.0
 * @since 1.0
 */
@Injectable()
export class AnonymousGuardGuard implements CanActivate {
  private sharedSrv = inject(SharedService);

  canActivate() {
    return !this.sharedSrv.user;
  }
}
